// extracted by mini-css-extract-plugin
module.exports = {"boldText":"_1oiU-BN1"};